import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { setToken } from "./redux/slices/authSlice";
import { Toaster } from "react-hot-toast";

const token =
  sessionStorage.getItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af") ||
  localStorage.getItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
// const user = JSON.parse(localStorage.getItem("user"));

if (token) {
  store.dispatch(setToken({ userAccessToken: token }));
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App /> 
        <Toaster position="top-right" reverseOrder={false} />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
